import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { createStore } from './Store';
import { ScrollToTop, getCMSObject, TeleScript, ErrorBoundary } from 'sg-ui-components';

import HomePage from './pages/home';
import Feedback from './pages/feedback';
import Promotions from './pages/promotions';
import SecondChancePromotion from './pages/secondChancePromotion';
import PromotionDetailsPage from './pages/promotionDetails';
import MyActivityPage from './pages/myActivity';
import SurveyPage from './pages/survey';
import PostClaimPage from './pages/postClaim';
import WinnersPage from './pages/winners';
import PageNotFound from './pages/404';
import Login from './pages/login';
import Register from './pages/register';
import Logout from './pages/logout';
import EnterPage from './pages/enter';
import AccountConfirmPage from './pages/accountConfirm';
import AwaitAccountConfirmationPage from './pages/awaitAccountConfirmation';
import ForgotPassword from './pages/forgotPassword';
import RecoverPasswordPage from './pages/recoverPassword';
import ProgressiveJackpotPage from './pages/progressiveJackpot';
import RedirectPage from './pages/redirect';
import Drawings from './pages/drawings';
import pointsForDrawingsDetailsPage from './pages/pointsForDrawingsDetailsPage';

import FaqPage from './pages/faq';
import RulesPage from './pages/rules';
import TermsPage from './pages/terms';
import PrivacyPage from './pages/privacy';
import ContactUsPage from './pages/contactUs';

import './styling/global.scss';

const app = document.getElementById('root');

const errorBoundaryTelescript = getCMSObject('data.messages.pageErrorMessages.jsonBlock');

render(
    <Provider store={createStore()}>
        <ErrorBoundary fallback={<TeleScript line={errorBoundaryTelescript?.rootFallback} />} details={{}}>
            <Router basename='/'>
                <ScrollToTop />
                <Suspense fallback={<div>Loading...</div>}>
                    <Switch>
                        <Route exact path='/' component={HomePage} />
                        <Route path='/home' component={HomePage} />
                        <Route path='/winners' component={WinnersPage} />
                        <Route path='/promotions' component={Promotions} />
                        <Route path='/drawings' component={Drawings} />
                        <Route path='/points-for-drawing-details/:sweepId' component={pointsForDrawingsDetailsPage} />
                        <Route path='/second-chance-promotion' component={SecondChancePromotion} />
                        <Route path='/promotion' component={PromotionDetailsPage} />
                        <Route path='/feedback' component={Feedback} />

                        <Route path='/faq' component={FaqPage} />
                        <Route path='/rules' component={RulesPage} />
                        <Route path='/terms' component={TermsPage} />
                        <Route path='/privacy' component={PrivacyPage} />
                        <Route path='/contact-us' component={ContactUsPage} />

                        <Route path='/post-claim' component={PostClaimPage} />
                        <Route path='/my-activity' component={MyActivityPage} />

                        <Route path='/enter' component={EnterPage} />
                        <Route path='/survey' component={SurveyPage} />
                        <Route path='/logout' component={Logout} />

                        {/* Custom pages built for SC Ensemble */}
                        <Route path='/login' component={Login} />
                        <Route path='/register' component={Register} />
                        <Route path='/account-confirm' component={AccountConfirmPage} />
                        <Route path='/await-account-confirmation' component={AwaitAccountConfirmationPage} />
                        <Route path='/forgot-password' component={ForgotPassword} />
                        <Route path='/recover-password' component={RecoverPasswordPage} />

                        <Route path='/progressive-jackpot-test' component={ProgressiveJackpotPage} />
                        <Route path='/redirect' component={RedirectPage} />

                        <Route path='*' component={PageNotFound} />
                    </Switch>
                </Suspense>
            </Router>
        </ErrorBoundary>
    </Provider>,
    app
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
